<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>基础数据</el-breadcrumb-item>
        <el-breadcrumb-item>金牌客服</el-breadcrumb-item>
        <el-breadcrumb-item>客服列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">客服列表</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="handleServiceCreate">添加客服</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="客服名称"
                      prop="name">
          <el-input v-model="query.name"
                    clearable
                    @input="fetchServiceList(true)"
                    placeholder="输入客服名称"></el-input>
        </el-form-item>
        <el-form-item label="标签"
                      prop="name">
          <el-input v-model="query.tags_keyword"
                    clearable
                    @input="fetchServiceList(true)"
                    placeholder="输入标签"></el-input>
        </el-form-item>
        <el-form-item label="院校"
                      prop="name">
          <el-input v-model="query.college_codes"
                    clearable
                    @input="fetchServiceList(true)"
                    placeholder="输入院校"></el-input>
        </el-form-item>
        <el-form-item label="专业"
                      prop="name">
          <el-input v-model="query.major_codes"
                    clearable
                    @input="fetchServiceList(true)"
                    placeholder="输入院校"></el-input>
        </el-form-item>
        <el-form-item label="状态"
                      prop="status">
          <el-select v-model="query.status"
                     placeholder="请选择"
                     @change="fetchServiceList(true)">
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台id"
                      prop="client_id">
          <el-select v-model="query.client_id"
                     placeholder="请选择客户端"
                     clearable
                     @change="fetchServiceList(true)"
                     style="width: 100%;">
            <el-option v-for="item in clients"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="divider"></div>
      <div class="action-wrap">
        <el-button type="primary"
                   @click="handleSearch">搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="name"
                           label="名称"
                           min-width="160"
                           align="center">
          </el-table-column>
          <el-table-column prop="avatar"
                           label="头像"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <img class="avatar"
                   :src="scope.row.avatar">
            </template>
          </el-table-column>
          <el-table-column prop="tags"
                           label="标签"
                           min-width="160"
                           align="center">
          </el-table-column>
          <el-table-column prop="mobile"
                           label="手机号"
                           min-width="160"
                           align="center">
          </el-table-column>
          <el-table-column prop="wechat"
                           label="微信号"
                           min-width="160"
                           align="center">
          </el-table-column>
          <el-table-column label="开放状态"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <el-tag type="success"
                      v-if="scope.row.open_status == 1">开放</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="180"
                           align="center"
                           fixed="right"
                           v-if="isfixed">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="text"
                         @click="handleToServiceEdit(scope.row, scope.$index)">编辑</el-button>
              <el-button class="remove-text-button"
                         size="mini"
                         type="text"
                         @click="handleToServiceRemove(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                                    style="margin-bottom:6px;"><span @click="handleToServiceEdit(scope.row, scope.$index)"
                          style="font-size:16px;color: #409EFF;">
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item command="d"
                                    style="margin-bottom:6px;"><span @click="handleToServiceRemove(scope.row, scope.$index)"
                          style="font-size:16px;color: #F56C6C;">
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { serviceList, serviceDestroy } from '@/api/common'
import { clientList } from '@/api/operation'
export default {
  data() {
    return {
      query: {
        name: '',
        status: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        client_ids: '',
      },
      pageTotal: 10,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '正常', value: '1' },
          { label: '关闭', value: '0' },
        ],
      },
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      clients: [],
    }
  },
  created() {
    this.parseQuery()
    this.fetchServiceList()
    this.fetchClientList()
  },
  methods: {
    fetchClientList() {
      clientList({ isPaging: 0 }).then((res) => {
        this.clients = res.list
        console.log('this.clients', this.clients)
      })
    },
    // 客服列表请求
    fetchServiceList(reset) {
      if (reset) {
        this.query.pageIndex = 1
      }
      serviceList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchServiceList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchServiceList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchServiceList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchServiceList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        1: '正常',
        2: '关闭',
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    // 金牌客服创建
    handleServiceCreate() {
      this.$router.push(`/service/create`)
    },
    // 金牌客服编辑
    handleToServiceEdit(row) {
      this.$router.push(`/service/edit/${row.id}`)
    },
    // 金牌客服删除
    handleToServiceRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          serviceDestroy({ id: row.id }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchServiceList()
          })
        })
        .catch(() => {})
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
  },
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .avatar {
      display: block;
      width: 48px;
      height: 48px;
      object-fit: cover;
      margin: 0 auto;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
